// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3I-gX","col":"CardReaderDesc_col__2k36K","label":"CardReaderDesc_label__35zkq"};